<div *ngxPermissionsOnly="[role.user]">
  @if (user) {
    <div>
      <ng-template #searchBox>
        <app-search-box
          dataCy="quote-search"
          [(value)]="searchQuery"
          (searchSubmit)="onSearchQueryChange()"
        />
      </ng-template>
      @if (showFilters() && showTitle()) {
        <div class="row">
          <div class="col-12 col-lg-9 list-title">
            <app-page-title content="Quotes"></app-page-title>
            <app-quote-list-tabs />
          </div>
          <div class="col-12 col-lg-3">
            <ng-container *ngTemplateOutlet="searchBox"></ng-container>
          </div>
        </div>
      }
      <div class="card-box">
        <div class="page-filters">
          <div class="filter-field">
            <span class="filter-field__label">Show only my:</span>
            <app-quote-list-filter
              [filterValue]="quoteFilter"
              (filterChange)="onQuoteFilterChange($event)"
            >
            </app-quote-list-filter>
          </div>
          <div class="filter-field">
            <span class="filter-field__label">Quote type:</span>
            <app-quote-variant-multiselect
              [selectedVariants]="selectedVariants"
              (selectionChange)="onVariantsChange($event)"
            ></app-quote-variant-multiselect>
          </div>
          <div class="filter-field">
            <span class="filter-field__label">Direction:</span>
            <app-quote-direction-select
              [showClear]="true"
              [isAllAvailable]="false"
              [direction]="selectedDirection"
              (directionChange)="onDirectionChange($event)"
            >
            </app-quote-direction-select>
          </div>
          <div class="filter-field">
            <span class="filter-field__label">Status:</span>
            <app-quote-status-multiselect
              [selectedStatuses]="selectedQuoteStatuses"
              (selectionChange)="onQuoteStatusSelectChange($event)"
            ></app-quote-status-multiselect>
          </div>
          @if (user?.hasCompanies() && user.canListCompanies()) {
            <div class="filter-field">
              <span class="filter-field__label">Company:</span>
              <app-company-multiselect
                [hideWhenEmpty]="true"
                [companyIds]="companyIdsFilter"
                (companyChange)="onCompanyMultiselectChange($event)"
              >
              </app-company-multiselect>
            </div>
          }
          <div class="filter-field">
            <span class="filter-field__label">Source:</span>
            <app-quote-source-multiselect
              [selectedSources]="selectedQuoteSources"
              (selectionChange)="onQuoteSourcesChange($event)"
            >
            </app-quote-source-multiselect>
          </div>
          <div class="filter-field">
            <span class="filter-field__label">Created at:</span>
            <app-date-picker
              [selectedRange]="createdAtRange"
              [showIcon]="true"
              (rangeChange)="onCreatedAtRangeChange($event)"
            ></app-date-picker>
          </div>
          @if (isClearFiltersVisible()) {
            <button
              pButton
              type="button"
              variant="text"
              class="new-filters__clear"
              (click)="clearFilters()"
            >
              <i class="pi pi-filter-slash"></i>
              Clear filters
            </button>
          }
          @if (showFilters() && !showTitle()) {
            <ng-container *ngTemplateOutlet="searchBox"></ng-container>
          }
        </div>
        <div class="list-header">
          <app-quote-list-batch-actions
            #batchActions
            [selectedQuotes]="selectedQuotes"
            [totalCount]="quoteList.totalItems"
            (selectAll)="selectAll()"
            (clearSelection)="clearSelection()"
            (selectionChange)="selectionChange($event)"
            (requestInfoChange)="requestInfoChange($event)"
            (batchDeleteComplete)="fetchQuotes()"
            (batchReplicateComplete)="fetchQuotes()"
            (batchSendComplete)="batchSendComplete()"
            (toggleEditor)="toggleBatchEditor()"
            [client]="client()"
          >
          </app-quote-list-batch-actions>
        </div>
        <app-quote-batch-mail-editor
          #batchEditor
          (batchSend)="onBatchSend($event)"
        >
        </app-quote-batch-mail-editor>
        <app-table
          [columns]="[
            {
              header: '<i class=\'pi pi-envelope\'></i>',
              field: 'openedAt',
              type: tableColumn.opened,
              hideOnMobile: true,
            },
            {
              header: 'Status',
              field: 'status',
              type: tableColumn.status,
              sortable: true,
            },
            {
              header: 'Updated at',
              field: 'updatedAt',
              type: tableColumn.timeAgo,
              sortable: true,
              hideOnMobile: true,
            },
            {
              header: 'Account Name',
              field: 'clientNames',
              type: tableColumn.default,
            },
            { header: 'Details', field: 'details', type: tableColumn.quote },
            {
              header: 'Valid to',
              field: 'validTo',
              type: tableColumn.date,
              sortable: true,
              hideOnMobile: true,
            },
            {
              header: 'Source',
              field: 'source',
              type: tableColumn.quoteSource,
              hideOnMobile: true,
            },
            {
              header: 'Sender / Creator',
              field: 'senderCreatorName',
              type: tableColumn.default,
              hideOnMobile: true,
            },
            { header: 'ID', field: 'displayId', hideOnMobile: true },
            {
              header: '<i class=\'pi pi-comment\'></i>',
              field: 'internalComment',
              type: tableColumn.editableComment,
              hideOnMobile: true,
            },
            {
              header: '<i class=\'pi pi-dollar\'></i>',
              field: 'fileNameInternal',
              type: tableColumn.download,
              hideOnMobile: true,
            },
            {
              header: '<i class=\'pi pi-download\'></i>',
              field: 'fileName',
              type: tableColumn.download,
              hideOnMobile: true,
            },
          ]"
          [value]="quoteList.items"
          [paginator]="quoteList.totalItems > gridParams.limit"
          [loading]="loading"
          [rows]="gridParams.limit"
          [first]="gridParams.first"
          [totalRecords]="quoteList.totalItems"
          (changePage)="onLoadPage($event.first / $event.rows + 1, $event.rows)"
          (sortRows)="onSortGrid($event)"
          (rowClick)="onClickRow($event.model)"
          (saveRow)="onSaveComment($event)"
          [(selection)]="selectedQuotes"
          [selectable]="true"
          (selectRow)="onSelectRow($event)"
          [contextMenuItems]="contextMenuItems"
          [(contextMenuSelection)]="contextMenuSelection"
        >
        </app-table>
        <ng-container *ngTemplateOutlet="batchActions.selectionBar()" />
      </div>
    </div>
  }
</div>
